import React, { useState, useEffect, useMemo } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { Table, TableContainer, Checkbox, Tooltip, IconButton, Paper, Button } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Loader } from "@egovernments/digit-ui-react-components";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import DialogContentModal from "../../../../templates/ApplicationDetails/components/DialogContent"

const EmpIdentifyNoc = ({ formData, tenantId, handleTabChange, handleNoWorkflowNoc, isJE, currentFormData }) => {
  const { data: { NOC: { NocDepartment: mdmsDepartments } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "NOC", [
    "NocDepartment",
  ]);
  console.log("currentFormDatas", currentFormData, mdmsDepartments);
  const [, setIsPreviewLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showNoDepartments, setShowNoDepartments] = useState(false); // <-- new state
  const [isAllSelected, setIsAllSelected] = useState(true);
  // For in-portal Request Letter preview
  const [iframeSrc, setIframeSrc] = useState("");
  const [smShow, setSmShow] = useState(false);
  const khasraDetails = formData?.khasraDetails || [];
  const tehsil = khasraDetails.length > 0 ? khasraDetails[0].tehsil : "";
  const district = khasraDetails.length > 0 ? khasraDetails[0].district : "";
  const villages = khasraDetails.length > 0 ? khasraDetails[0].villageName : "Lucknow";
  const applicantNOCData = formData?.nocDetails?.applicantNOCData;
  const officerNOCData = formData?.nocDetails?.officerNOCData || [];
  const { data, isLoading, isSuccess, error } = Digit.Hooks.noc.useNOCExcelSearch(tenantId, formData?.selectedOffice, tehsil, district, villages, {});

  function fetchDepartmentMessages(data, departmentList) {
    if (!departmentList) return { departments: [], noDepartments: [] };
    if (officerNOCData?.length > 0) {
      const departments = officerNOCData;

      const noDepartments = departmentList

        .filter((dept) => !officerNOCData.find((d) => d.code === dept.code))

        .map((dept) => ({
          code: dept.code,

          message: dept.message,

          name: dept.name,
        }));

      return { departments, noDepartments };
    }

    if (!data) {
      const noDepartmentsList = departmentList.map((dept) => ({
        code: dept.code,

        message: dept.message,

        name: dept.name,
      }));

      return { departments: [], noDepartments: noDepartmentsList };
    }

    const departments = departmentList

      .filter((dept) => data[dept.code] === "Yes" || data[dept.code] === "YES")

      .map((dept) => ({
        code: dept.code,

        message: dept.message,

        name: dept.name,
      }));

    const noDepartments = departmentList

      .filter(
        (dept) =>
          data[dept.code] === "No" || data[dept.code] === "NO" || data[dept.code] === "" || data[dept.code] === undefined || data[dept.code] === null
      )

      .map((dept) => ({
        code: dept.code,

        message: dept.message,

        name: dept.name,
      }));

    return { departments, noDepartments };
  }

  const { departments, noDepartments } = useMemo(() => fetchDepartmentMessages(data?.[0]?.Departments, mdmsDepartments?.[0]?.department), [
    data,
    mdmsDepartments,
    formData?.nocDetails?.officerNOCData,
  ]);
  console.log(data, "noanddepartmentss", formData?.nocDetails?.officerNOCData);

  const nocIndexes = useMemo(() => {
    const list = formData?.nocList || [];
    const byType = {};
    list.forEach((item) => {
      if (item?.nocType) byType[item.nocType] = item;
    });
    return { list, byType };
  }, [formData?.nocList]);

  const findNocForDepartment = (dept) => {
    if (!dept) return undefined;
    const code = dept.code;
    console.log("codedept", code, dept, nocIndexes);

    return nocIndexes.byType[code];
  };

  const handleOpenDoc = (url) => {
    if (url) window.open(url, "_blank");
  };

  // Open Request Letter in an in-portal iframe dialog (same pattern as NOCInfo)
  const handleOpenRequestLetter = (url) => {
    if (url) {
      setIframeSrc(url);
      setSmShow(true);
    }
  };

  // Resolve the Request Letter URL from a nocItem's nocLetterInfo field
  const getRequestLetterUrl = (nocItem) => {
    if (!nocItem) return null;
    let raw = nocItem?.nocLetterInfo;
    if (typeof raw === "string") {
      try { raw = JSON.parse(raw); } catch (e) { raw = null; }
    }
    const obj = Array.isArray(raw)
      ? raw.find((r) => r?.fileStoreUrl || r?.url) || raw[0]
      : raw;
    return obj?.fileStoreUrl || obj?.url || nocItem?.requestLetterUrl || null;
  };

  // Prepare defaultValues for checkboxes
  const defaultCheckboxValues = {};

  // Mark all "Yes" departments
  (departments || []).forEach((dept) => {
    if (dept.code) {
      defaultCheckboxValues[dept.code] = officerNOCData?.length > 0 ? officerNOCData.some((item) => item.code === dept.code) : true; // assume all checked on first load if officerNOCData is empty
    }
  });

  // Mark "No" departments as unchecked
  (noDepartments || []).forEach((dept) => {
    if (dept.code) {
      defaultCheckboxValues[dept.code] = false;
    }
  });
  const { control, handleSubmit, setValue, reset } = useForm({
    defaultValues: { departments: defaultCheckboxValues },
  });

  const watchedDepartments = useWatch({
    control,
    name: "departments",
  });

  useEffect(() => {
    if (departments?.length > 0 || noDepartments?.length > 0) {
      console.log("defaultFromEffects", defaultCheckboxValues);

      const values = { ...defaultCheckboxValues };
      reset({ departments: values });
    }
    // eslint-disable-next-line
  }, [JSON.stringify(departments), JSON.stringify(noDepartments), JSON.stringify(officerNOCData), reset]);

  useEffect(() => {
    const allDepartments = [...departments, ...(showNoDepartments ? noDepartments : [])];

    if (!allDepartments.length) return;

    const selectedCount = allDepartments.filter((dept) => watchedDepartments?.[dept.code]).length;

    // if all selected -> Unselect All
    // if even one unchecked -> Select All
    setIsAllSelected(selectedCount === allDepartments.length);
  }, [watchedDepartments, departments, noDepartments, showNoDepartments]);

  const handleAddNOC = () => {
    setShowNoDepartments(true);
  };

  const handleSelectAll = () => {
    const newValue = !isAllSelected;

    const allValues = {};

    [...departments, ...(showNoDepartments ? noDepartments : [])].forEach((dept) => {
      allValues[dept.code] = newValue;
    });

    reset({ departments: allValues });
  };

  const onSubmit = (data) => {
    // Get selected department names (checkboxes)
    const selectedNames = Object.entries(data.departments)
      .filter(([_, checked]) => checked)
      .map(([name]) => name);

    // Map selected names to their department info (message and name)
    const allDeptList = [...departments, ...(showNoDepartments ? noDepartments : [])];
    const selectedDepartments = allDeptList
      .filter((dept) => selectedNames.includes(dept.code))
      .map((dept) => ({
        name: dept.name,
        message: dept.message,
        code: dept.code,
      }));

    handleNoWorkflowNoc(
      {
        ...formData?.nocDetails,
        officerNOCData: selectedDepartments,
      },
      setIsSubmitted
    );
  };

  const getUploadedNocDoc = (dept) => {
    if (!dept) return null;
    const deptName = (dept.name || "").toLowerCase().trim();
    const deptCode = (dept.code || "").toLowerCase().trim();

    const getFid = (d) => d?.fileStoreId || d?.filestoreid || d?.filesstoreid;
    const isNoc = (d) =>
      d?.isNoc === true ||
      d?.isNoc === "true" ||
      d?.isNOC === true ||
      d?.isNOC === "true" ||
      d?.isnoc === true ||
      d?.isnoc === "true";

    const isDeptMatch = (str) => {
      if (!str) return false;
      const lower = str.toLowerCase().trim();
      return (
        (deptName && (lower === deptName || lower.includes(deptName) || deptName.includes(lower))) ||
        (deptCode && (lower === deptCode || lower.includes(deptCode) || deptCode.includes(lower)))
      );
    };

    // 1. Direct check in formData.documents & currentFormData.documents
    const formDocs = [
      ...(Array.isArray(formData?.documents) ? formData.documents : []),
      ...(Array.isArray(currentFormData?.documents) ? currentFormData.documents : []),
      ...(Array.isArray(formData?.nocDetails?.documents) ? formData.nocDetails.documents : []),
      ...(Array.isArray(currentFormData?.nocDetails?.documents) ? currentFormData.nocDetails.documents : []),
    ];

    for (const d of formDocs) {
      const fid = getFid(d);
      if (fid && isNoc(d)) {
        const docType = d?.documentType || d?.additionalDetails?.title || d?.additionalDetails?.fileName || d?.nocType || d?.title || "";
        if (isDeptMatch(docType)) {
          return fid;
        }
      }
    }

    // 2. Gather applicantDocs from nocListApplicantDoc / nocList / nocDetails
    const applicantDocsSources = [
      formData?.nocDetails?.nocListApplicantDoc,
      currentFormData?.nocDetails?.nocListApplicantDoc,
      formData?.nocList,
      currentFormData?.nocList,
      formData?.nocDetails?.nocList,
      currentFormData?.nocDetails?.nocList,
    ];

    for (const src of applicantDocsSources) {
      if (!src) continue;

      const itemsList = Array.isArray(src) ? src : [src];

      for (const item of itemsList) {
        if (!item) continue;
        const itemNocName = item?.nocName || item?.nocType || item?.department || item?.additionalDetails?.title || "";
        const itemMatchesDept = isDeptMatch(itemNocName);

        // A) Inspect item.documents (e.g. nocListApplicantDoc[0].documents)
        if (Array.isArray(item?.documents)) {
          for (const d of item.documents) {
            const fid = getFid(d);
            if (fid && isNoc(d)) {
              const docType = d?.documentType || d?.additionalDetails?.title || d?.additionalDetails?.fileName || "";
              if (isDeptMatch(docType) || itemMatchesDept) {
                return fid;
              }
            }
          }
          if (itemMatchesDept) {
            for (const d of item.documents) {
              const fid = getFid(d);
              if (fid) return fid;
            }
          }
        }

        // B) Inspect item directly if item itself is a doc object
        const fid = getFid(item);
        if (fid && isNoc(item)) {
          const docType = item?.documentType || itemNocName;
          if (isDeptMatch(docType) || itemMatchesDept) {
            return fid;
          }
        }
      }
    }

    // 3. Fallback: match any doc in nocListApplicantDoc[0].documents matching department
    for (const src of applicantDocsSources) {
      if (!src) continue;
      const itemsList = Array.isArray(src) ? src : [src];
      for (const item of itemsList) {
        if (item && Array.isArray(item.documents)) {
          for (const d of item.documents) {
            const fid = getFid(d);
            if (fid) {
              const docType = d?.documentType || d?.additionalDetails?.title || "";
              if (isDeptMatch(docType)) {
                return fid;
              }
            }
          }
        }
      }
    }

    return null;
  };

  if (isLoading || isDataLoading) {
    return <Loader />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div
        style={{
          backgroundColor: "#f5f5f5",
          padding: "10px",
          borderRadius: "5px",
          color: "#333",
          marginBottom: "15px",
          fontWeight: "bold",
        }}
      >
        <p>
          <strong>Please note:</strong> The NOCs selected by the officer will be considered the final required NOCs for approval. Make sure to review
          the list carefully.
        </p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ backgroundColor: "white", borderRadius: "4px", width: "150px", border: "1px solid #ccc", color: "#333" }}
          type="button"
          // disabled={!isJE}
          onClick={handleSelectAll}
        >
          {isAllSelected ? (
            <React.Fragment>
              <CheckBoxIcon style={{ marginRight: "8px" }} />
              Unselect All
            </React.Fragment>
          ) : (
            <React.Fragment>
              <CheckBoxOutlineBlankIcon style={{ marginRight: "8px" }} />
              Select All
            </React.Fragment>
          )}
        </Button>
      </div>
      <TableContainer component={Paper} className="table-container">
        <Table stickyHeader className="application-table">
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th style={{ width: "10%" }}>Sr. No.</th>
              <th style={{ width: formData?.nocList?.length > 0 ? "30%" : "55%" }}>Department Name</th>
              <th style={{ width: "25%" }}>Required</th>
              {/* Request Letter column — visible to employee on shortfall/view file */}
              <th style={{ width: "15%" }}>Request Letter</th>
              {formData?.nocList?.length > 0 && <th style={{ width: "15%" }}>View NOC</th>}
              <th style={{ width: "25%" }}>Uploaded NOC</th>
            </tr>
          </thead>
          <tbody>
            {(departments || []).map((dept, index) => (
              <tr key={dept.code}>
                <td>{index + 1}</td>
                <td>
                  {dept.name}
                  <Tooltip title={dept.message} arrow>
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </td>
                <td style={{ textAlign: "center" }}>
                  <Controller
                    name={`departments.${dept.code}`}
                    control={control}
                    // disabled={!isJE}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        checked={!!field.value}
                        color="primary"
                        onChange={(e) => field.onChange(e.target.checked)}
                        sx={{ padding: "0" }}
                      // disabled={!isJE}
                      />
                    )}
                  />
                </td>
                {/* Request Letter column */}
                <td style={{ textAlign: "center" }}>
                  {(() => {
                    const nocItem = findNocForDepartment(dept);
                    const reqUrl = getRequestLetterUrl(nocItem);
                    return reqUrl ? (
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={() => handleOpenRequestLetter(reqUrl)}
                        sx={{ fontSize: "12px", minWidth: "60px" }}
                      >
                        View
                      </Button>
                    ) : ("-");
                  })()}
                </td>
                {formData?.nocList?.length > 0 && (
                  <td style={{ textAlign: "center" }}>
                    {(() => {
                      const nocItem = findNocForDepartment(dept);
                      const status = nocItem?.applicationStatus;
                      const isApproved = status === "NOC_APPROVED";
                      const url = nocItem?.nocApprovedLetterUrl || nocItem?.nocDeemedLetterUrl;
                      console.log({ nocItem, isApproved, url });
                      return isApproved && url ? (
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={() => handleOpenDoc(url)}
                          sx={{ fontSize: "12px", minWidth: "60px" }}
                        >
                          View
                        </Button>
                      ) : (
                        "-"
                      );
                    })()}
                  </td>
                )}
                <td>
                  {(() => {
                    const fileStoreId = getUploadedNocDoc(dept);
                    if (fileStoreId) {
                      return (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}>
                          <FaFilePdf
                            color="#a10505"
                            style={{ width: "20px", height: "26px", cursor: "pointer" }}
                            onClick={() => getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading)}
                            title="View NOC Document"
                          />
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading)}
                            sx={{ fontSize: "12px", minWidth: "50px" }}
                          >
                            View
                          </Button>
                        </div>
                      );
                    }
                    return "-";
                  })()}
                </td>
              </tr>
            ))}
            {/* Render noDepartments below when Add NOC is clicked */}
            {showNoDepartments &&
              (noDepartments || []).map((dept, index) => (
                <tr key={dept.code}>
                  <td>{departments.length + index + 1}</td>
                  <td>
                    {dept.name}
                    <Tooltip title={dept.message} arrow>
                      <IconButton size="small">
                        <InfoOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Controller
                      name={`departments.${dept.code}`}
                      control={control}
                      // disabled={!isJE}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={!!field.value}
                          color="primary"
                          onChange={(e) => field.onChange(e.target.checked)}
                          sx={{ padding: "0" }}
                        // disabled={!isJE}
                        />
                      )}
                    />
                  </td>
                  {/* Request Letter column for noDepartments */}
                  <td style={{ textAlign: "center" }}>
                    {(() => {
                      const nocItem = findNocForDepartment(dept);
                      const reqUrl = getRequestLetterUrl(nocItem);
                      return reqUrl ? (
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={() => handleOpenRequestLetter(reqUrl)}
                          sx={{ fontSize: "12px", minWidth: "60px" }}
                        >
                          View
                        </Button>
                      ) : ("-");
                    })()}
                  </td>
                  {formData?.nocList?.length > 0 && (
                    <td style={{ textAlign: "center" }}>
                      {(() => {
                        const nocItem = findNocForDepartment(dept);
                        const status = nocItem?.applicationStatus || nocItem?.applicationstatus;
                        const isApproved = status === "NOC_APPROVED";
                        const url = nocItem?.nocApprovedLetterUrl;
                        return isApproved && url ? (
                          <Button variant="outlined" size="small" onClick={() => handleOpenDoc(url)}>
                            View
                          </Button>
                        ) : (
                          "-"
                        );
                      })()}
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
      </TableContainer>
      {/* {isJE && ( */}
      <div style={{ marginTop: 16, display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ backgroundColor: "rgb(21, 124, 179)", borderRadius: "4px" }}
          disabled={isSubmitted}
        >
          Update & Save
        </Button>
        <Button variant="contained" color="primary" style={{ backgroundColor: "rgb(21, 124, 179)", borderRadius: "4px" }} onClick={handleAddNOC}>
          <AddIcon style={{ marginRight: "8px" }} /> Add NOC
        </Button>
      </div>
      {/* )} */}
      {/* Request Letter preview dialog */}
      {iframeSrc && (
        <DialogContentModal
          title={"Request Letter"}
          dataOpen={smShow}
          onClose={() => {
            setSmShow(false);
            setIframeSrc("");
          }}
        >
          <div className="iframe-container">
            <iframe className="fastPas-iframe" src={iframeSrc} title="Request Letter Viewer" />
          </div>
        </DialogContentModal>
      )}
    </form>
  );
};

export default EmpIdentifyNoc;
